/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { FC } from 'react';
import { ButtonItem, ContentfulContentTypes } from 'store/landing/types';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import MessageCardGroupNativeButtons from './MessageCardGroupNativeButtons/MessageCardGroupNativeButtons';
import styles from './MessageCardGroup.module.scss';

export interface MessageCardGroupProps {
  buttonItem?: ButtonItem;
  title: string;
  heading1?: string;
  heading2?: string;
  description?: string;
}

const MessageCardGroup: FC<MessageCardGroupProps> = ({ buttonItem, title, heading1, heading2, description }) => {
  const { theme } = useLandingPageContext();
  if (!buttonItem) {
    return null;
  }

  const { contentType } = buttonItem;
  if (contentType === ContentfulContentTypes.landingPageButton) {
    return (
      <div className={cn(styles.container, styles[`theme-${theme}`])}>
        {heading2 && <h2 className={styles.heading2} dangerouslySetInnerHTML={{ __html: heading2 }} />}
        {heading1 && <h1 className={styles.heading1} dangerouslySetInnerHTML={{ __html: heading1 }} />}
        {title && <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />}
        {description && <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />}
        {buttonItem.button.label && (
          <a
            className={styles.messageGroupBtn}
            href={buttonItem.button.referenceUrl}
            dangerouslySetInnerHTML={{ __html: buttonItem.button.label }}
          />
        )}
      </div>
    );
  }

  if (contentType === ContentfulContentTypes.landingPageButtonNativeAppDownloadFromStore) {
    return <MessageCardGroupNativeButtons buttonNativeApp={buttonItem.buttonNativeApp} />;
  }

  return null;
};

export default MessageCardGroup;
